import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { ChevronDown, ChevronUp } from 'lucide-react'

type SubmenuKey = '회사소개'|'전자영수증'|"디지털 마케팅"|'문의하기'
const submenuMap: Record<SubmenuKey,string[]> = {
  회사소개: [],
  "디지털 마케팅": [],
  전자영수증: [],
  문의하기: [],
}
const pathMap: Record<string,string> = {
  전자영수증:'/mpaper',
  "디지털 마케팅":'/mkt',
  문의하기:'/contact'
}

interface Props {
  subtitles: SubmenuKey[]
  hrefs: string[]
  isMobile?: boolean
  onNavigate?: () => void
  textColor?: string
  hoverColor?: string
  submenuTextColor?: string
  submenuHoverColor?: string
}

export default function NavigationBar({ subtitles, hrefs, isMobile, onNavigate, textColor = "text-black", hoverColor = "hover:text-gray-400", submenuTextColor = "text-black", submenuHoverColor = "hover:text-gray-400" }: Props) {
  const [openKey, setOpenKey] = useState<SubmenuKey|null>(null)

  return (
    <ul className={`
        flex flex-col
        desktop:flex-row desktop:space-x-6 desktop:space-y-0
        space-y-4
      `}>
      {subtitles.map((label, idx) => {
        const hasSub = submenuMap[label].length > 0
        const isOpen = openKey === label
        const to = hrefs[idx];
        return (
          <li
            key={label}
            className={!isMobile && hasSub ? 'relative group' : ''}
          >
            <button
              onClick={() => {
                if (!isMobile || !hasSub) return
                setOpenKey(isOpen ? null : label)
              }}
              className={`flex items-center justify-between w-full text-xl  font-semibold ${textColor}`}
            >
          
          {hasSub
            ? <span className={`px-5 ${hoverColor}`}>{label}</span>
            : <Link to={to} className={`flex-1 text-left px-5 ${hoverColor}`}>
                {label}
              </Link>
          }
              {hasSub && isMobile && (
                isOpen
                  ? <ChevronUp size={20}/>
                 : <ChevronDown size={20}/>
              )}
            </button>
            {!isMobile && hasSub && (
              <ul className="
                  hidden
                  group-hover:block
                  absolute left-0 top-full pt-4
                  bg-white z-50
                ">
                {submenuMap[label].map(sub => (
                  <li key={sub}>
                    <Link
                      to={pathMap[sub]}
                      className="block px-4 py-2 text-center font-roboto font-semibold whitespace-nowrap text-gray-500 hover:bg-gray-100"
                    >
                      {sub}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
            {isMobile && isOpen && (
              <ul className="mt-2 ml-7 space-y-2">
                {submenuMap[label].map(sub => (
                  <li key={sub}>
                    <Link
                      to={pathMap[sub]}
                      className={`block  ${submenuTextColor} ${submenuHoverColor}`}
                    >
                      {sub}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        )
      })}
    </ul>
  )
}